import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ShoppingCart } from 'lucide-react';
import { handleAddToCart } from '../utils/AddRemoveCartItems';
import LoginModal from './LoginModal';
import { baseUrl } from '../apis';

const ProductCard = ({ data }) => {
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);

  const onAddToCart = (e) => {
    // Card itself is a Link to the product page — keep the click on the
    // cart button from also triggering that navigation.
    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(data._id, dispatch, () => setShowLogin(true));
  };

  return (
    <>
      <Link to={`/product/${data.name_id}`} className="block min-w-0 sm:w-1/3 md:w-1/4 lg:w-1/5 sm:p-2 no-underline group">
        <div className="h-full flex flex-col bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300">
          <div className="aspect-square bg-gray-50 flex items-center justify-center overflow-hidden rounded-t-xl p-2 sm:p-3">
            <img
              src={`${baseUrl}/images/${data.image}`}
              alt={data.name}
              className="h-full w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.02]"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="flex-1 flex flex-col p-2.5 sm:p-3 border-t border-gray-100">
            <h6 className="text-[13px] sm:text-sm font-semibold text-[#1B1F4B] leading-snug line-clamp-2 min-h-[2.5em] break-words">
              {data.name}
            </h6>
            <div className="mt-auto pt-2 flex items-center justify-between gap-2">
              <p className="text-[15px] sm:text-base md:text-lg text-[#2D3092] font-bold">₹{data.price}</p>
              <button
                type="button"
                onClick={onAddToCart}
                aria-label={`Add ${data.name} to cart`}
                className="flex-shrink-0 w-8 h-8 rounded-full bg-[#2D3092] hover:bg-indigo-700 text-white flex items-center justify-center transition-colors"
              >
                <ShoppingCart size={14} strokeWidth={2} />
              </button>
            </div>
          </div>
        </div>
      </Link>
      <LoginModal show={showLogin} onClose={() => setShowLogin(false)} />
    </>
  );
};

export default ProductCard;
